import React from 'react';
import styled from 'styled-components';

const ContainerGrid = styled.div`
    width: 100%;
    background-color: #f6f6f6;
    border: 1px solid #caced1;
    font-size: 11px;
`;

export default class Grid extends React.Component{
    constructor(props){
        super(props);
        this.onChangeRadio = this.onChangeRadio.bind(this);
    }

    onChangeRadio(event,col,row,keyRow){
        const target = event.target;        
        const value = target.value;

        row[col.field] = value;
        row.index = keyRow;
        this.props.onChangeRadiobutton(row);        
    }

    render(){
        const altura = {minHeight: this.props.altura};
        return(
            <ContainerGrid style={altura}>
                <table className="table table-condensed table-striped grid">
                    <thead>
                        <tr>{
                            this.props.columnas.map((col,key) => {
                                return <th key={key}>{col.header}</th>;
                            })}
                        </tr>
                    </thead>

                    <tbody>{
                        this.props.data.map((row, keyRow) => {
                            return <tr key={keyRow}>{
                                this.props.columnas.map((col, keyCol) => {
                                    if( col.input && col.input.type === "radio" ){
                                        return <td key={keyCol} style={{width: col.width + "px", textAlign: col.align}}>
                                            <input type="radio"
                                                name={col.input.name + keyRow}
                                                value={col.input.value}
                                                checked={col.input.isChecked(row, col.input.value)}
                                                onChange={(event) => this.onChangeRadio(event,col,row,keyRow)}
                                            />
                                            </td>
                                    }else{
                                        return <td key={keyCol} style={{width: col.width + "px", textAlign: col.align}}>
                                                {(col.type && col.type === "decimal"?parseFloat(row[col.field]).toFixed(2):row[col.field])}
                                            </td>
                                    }
                                })
                            }</tr>
                        })}
                    </tbody>
                </table>
            </ContainerGrid>
        );
    }
}